import { IServiceSettingsMap, IServiceSetting } from 'common/types/common/service';

export const SERVICE_SETTINGS_MAP: IServiceSettingsMap = {
  163: { icon: 'allFuel' },
  162: {
    name: 'Diesel fuel',
    icon: 'dieselFuel',
    stationCardDisplayOrder : 1
  },
  30 : {
    name: 'Petrol',
    icon: 'petrol',
    stationCardDisplayOrder : 2
  },
  40 : {
    name: 'AdBlue',
    icon: 'addBlue',
    stationCardDisplayOrder : 4
  },
  80 : {
    name: 'Gas',
    icon: 'gas',
    stationCardDisplayOrder : 3
  },
  164: { icon: 'storeOutlined' },
  60 : { icon: 'assignmentOutlined' },
  999: { icon: 'assignment' },
  165: { icon: 'roads' },
  167: { icon: 'currency' },
  122: {
    name: 'Fuel, other',
    stationCardDisplayOrder : 5
  },
  299: {
    icon: 'charging'
  }
} as const;

export const getServiceSettingsById = (id: string): IServiceSetting =>
  (SERVICE_SETTINGS_MAP[id] || {});

export const getStationCardDisplayOrderByCode = (code: string) => (
  (SERVICE_SETTINGS_MAP[code] || {}).stationCardDisplayOrder
);
